export default function lowercase(input=""){
    return input.toLowerCase();
}